<template>
  <div class="display-flex flex-wrap gap-2">
    <f7-chip
      v-for="t in typesForCategory"
      :key="t.code"
      class="type-chip"
      :class="
        modelValue.includes(t.code)
          ? 'chip-selected'
          : 'chip-unselected'
      "
      outline
      @click="toggle(t.code)"
      role="checkbox"
      :aria-checked="modelValue.includes(t.code)"
      tabindex="0"
      @keydown.enter="toggle(t.code)"
      @keydown.space.prevent="toggle(t.code)"
    >
      <template #media>
        <f7-icon material="check" :size="14" v-if="modelValue.includes(t.code)" />
        <f7-icon material="add" :size="14" v-else />
      </template>
      {{ $t(t.label) }}
    </f7-chip>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { GROUP_TYPES_BY_CATEGORY } from '../../constants/group-taxonomy.js'

const props = defineProps({
  category: { type: String, default: null },
  modelValue: { type: Array, default: () => [] },
  exclude: { type: String, default: null },
})
const emit = defineEmits(['update:modelValue'])

const typesForCategory = computed(() => {
  const all = props.category ? (GROUP_TYPES_BY_CATEGORY[props.category] ?? []) : []
  if (props.exclude) return all.filter((t) => t.code !== props.exclude)
  return all
})

function toggle(code) {
  const next = props.modelValue.includes(code)
    ? props.modelValue.filter((c) => c !== code)
    : [...props.modelValue, code]
  emit('update:modelValue', next)
}
</script>

<style scoped>
.type-chip {
  height: 32px;
  font-size: 13px;
  font-weight: 500;
}
.chip-selected {
  background: var(--f7-theme-color);
  color: var(--f7-on-primary, #fff);
  border: 1px solid var(--f7-theme-color);
  font-weight: 600;
}
.chip-unselected {
  background: var(--f7-surface-container, #e8e8e8);
  color: var(--f7-on-surface, #1c1b1f);
  border: 1px solid var(--f7-list-item-border-color, #79747e);
}
.chip-unselected:hover {
  background: color-mix(in srgb, var(--f7-on-surface) 8%, var(--f7-surface-container, #e8e8e8));
}
</style>